import Form, { ButtonItem, ButtonOptions, CustomRule, Item, Label, RequiredRule } from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import React, { useCallback, useEffect, useRef } from "react";
import { ValidationSummary } from "devextreme-react/validation-summary";
import notify from "devextreme/ui/notify";
import { useNavigate } from "react-router";
import { useGetSecurityQuestions } from "../api/get-security-questions";
import { useChangeSecurityAnswerMutation } from "../api/change-security-answer";

const securityAnswerEditorOptions = {
    placeholder: 'Security Answer',
    mode: 'text',
    validationMessagePosition: 'down'
};
const confirmAnswerEditorOptions = {
    placeholder: 'Confirm Answer',
    mode: 'text',
    validationMessagePosition: 'down'
};

const submitButtonAttributes = { class: 'submit-button' };

export default function SecurityQuestionControl() {

    const formData = useRef({ securityAnswer: '', confirmAnswer: '', securityQuestionID: 1 as number });
    const navigate = useNavigate();
    const options = useGetSecurityQuestions();
    const mutation = useChangeSecurityAnswerMutation();

    useEffect(() => {
        if (mutation.isLoading)
            return;

        if (mutation.data === undefined)
            return;

        if (mutation.data?.isOk) {
            notify('Security Answer has been updated', 'success', 2500);
        } else {
            notify(mutation.data?.message, 'error', 2000);
        }
    }, [mutation.isLoading, mutation]);

    const onSubmit = useCallback(async (e: any) => {
        e.preventDefault();
        const { securityAnswer, securityQuestionID } = formData.current;
        await mutation.mutate({ securityQuestionID: securityQuestionID, answer: securityAnswer });
    }, [mutation]);

    const confirmAnswer = useCallback(
        ({ value }: any) => value === formData.current.securityAnswer,
        []
    );

    return <>
        <form onSubmit={onSubmit}>
            <Form formData={formData.current} disabled={mutation.isLoading} requiredMark={""}
                showValidationSummary={true}
                colCount={2} width={470} style={{ margin: "0px auto" }}>
                <Item
                    dataField={'securityQuestionID'}
                    editorType={'dxSelectBox'}
                    colSpan={2}
                    editorOptions={{
                        dataSource: options.data,
                        disabled: options.isLoading,
                        displayExpr: 'securityQuestionText',
                        valueExpr: 'securityQuestionID'
                    }}>
                    <Label text={'Security Question'} />
                    <RequiredRule message="Security Question is required" />
                </Item>
                <Item
                    dataField={'securityAnswer'}
                    editorType={'dxTextBox'}
                    colSpan={2}
                    editorOptions={securityAnswerEditorOptions}>
                    <RequiredRule message="Security Answer is required" />
                    <Label text={'Security Answer'} />
                </Item>
                <Item
                    dataField={'confirmAnswer'}
                    editorType={'dxTextBox'}
                    colSpan={2}
                    editorOptions={confirmAnswerEditorOptions}
                >
                    <RequiredRule message="Confirm Answer is required" />
                    <CustomRule
                        message={'Answers do not match'}
                        validationCallback={confirmAnswer}
                    />
                    <Label text={'Confirm Answer'} />
                </Item>
                <ButtonItem horizontalAlignment="center">
                    <ButtonOptions
                        elementAttr={submitButtonAttributes}
                        useSubmitBehavior={true}
                        width={'100%'}
                    >
                        <span className="dx-button-text">
                            {
                                mutation.isLoading
                                    ? <LoadIndicator width={'24px'} height={'24px'} visible={true} />
                                    : 'Save'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>
                <ButtonItem horizontalAlignment="center">
                    <ButtonOptions
                        useSubmitBehavior={false}
                        width={'100%'}
                        disabled={mutation.isLoading}
                        onClick={() => {
                            navigate('/home');
                        }}
                    >
                        <span className="dx-button-text">Cancel</span>
                    </ButtonOptions>
                </ButtonItem>
                <ValidationSummary id="summary"></ValidationSummary>
            </Form>
        </form>
    </>
}

